import * as React from "react";
import FormField from "@amzn/awsui-components-react/polaris/form-field";
import Select from "@amzn/awsui-components-react/polaris/select";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import {
  FeatureTypePair, FilterSelection, featureOptions, typeOptions, selectFeature, selectType,
} from "./feature-type-filter";

interface Props {
  items: FeatureTypePair[];
  selection: FilterSelection;
  onChange: (next: FilterSelection) => void;
  placeholder: string;
  // Extra controls rendered in the same row after the two dropdowns.
  children?: React.ReactNode;
}

// Two linked dropdowns in one horizontal row. Picking one side narrows the
// other; "All" on either side clears the other. See feature-type-filter.ts.
const FeatureTypeFilters: React.FC<Props> = ({ items, selection, onChange, placeholder, children }) => (
  <SpaceBetween size="s" direction="horizontal">
    <FormField label="Feature Name">
      <Select
        selectedOption={selection.feature}
        onChange={({ detail }) => onChange(selectFeature(items, detail.selectedOption, selection.type))}
        options={featureOptions(items, selection.type)}
        placeholder={placeholder}
      />
    </FormField>
    <FormField label="Customer Type Name">
      <Select
        selectedOption={selection.type}
        onChange={({ detail }) => onChange(selectType(items, detail.selectedOption, selection.feature))}
        options={typeOptions(items, selection.feature)}
        placeholder={placeholder}
      />
    </FormField>
    {children}
  </SpaceBetween>
);

export default FeatureTypeFilters;
